<div class="modal-header align-items-center">
  <div class="col">
    <h4 class="modal-title">
      <span translate [innerHTML]="notification.subject"></span>
    </h4>
  </div>
  <div class="col-auto">
    <button (click)="onClose()" aria-label="Close" class="close" type="button">
      <span aria-hidden="true" class="fa-solid fa-xmark"></span>
    </button>
  </div>
</div>

<div class="modal-body">
  <div class="h5">
    <span translate class="mr-2">Notification send</span>
    <span class="badge badge-outline badge-primary">
      <span [innerHTML]="notification.date | date:'medium'"></span>
    </span>
  </div>
  <p [innerHTML]="notification.message"></p>
</div>

<scitis-modal-footer
    [okButtonText]="closeButtonText"
    [showCancelButton]="false"
    (okButtonPressed)="onClose()">
</scitis-modal-footer>
